(ns teamoesterreich.admin-mode.training.training-user-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.selection.selection-table :as table]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.modal.enter-amount-modal :as enter-amount-modal]
            [teamoesterreich.admin-mode.data.trainingMember :as d-trainingMember]
            [teamoesterreich.admin-mode.data.training :as d-training]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.util.helper :as h]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.check-box :refer [check-box]]
            [reagent-material-ui.icons.check-box-outline-blank :refer [check-box-outline-blank]]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.cloud-download :refer [cloud-download]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]

            [reagent-material-ui.icons.how-to-reg :refer [how-to-reg]]
            [reagent-material-ui.icons.airline-seat-recline-normal :refer [airline-seat-recline-normal]]
            [reagent-material-ui.icons.space-bar :refer [space-bar]]
            ))



(defn count-true [map_]
  (count (filter second map_)))


(def responseState-map {"accepted" "zugesagt" "declined" "abgelehnt" "invalid" "ungültig" "unknown" "-" })
(def memberState-map {"participated" "teilgenommen" "absent" "abwesend" "invalid" "ungültig" "unknown" "-" })



(defn info-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label "bearbeiten"
                        :onClick (fn []
                                   (log/debug "bearbeiten geklickt " cell-data)
                                   (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] cell-data))
                        } [info {:fontSize "small"}]])))

(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn date-time-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(js/console.log l-date)
    (if (> (count cell-data) 10)
      (r/as-element [:span (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4)) [:br] (str (subs cell-data 9 11) ":" (subs cell-data 11 13))])
      (r/as-element[:span"-"]))))

(defn response-state-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (get responseState-map (str cell-data))])))

(defn state-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (get memberState-map (str cell-data))])))

(defn remove-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "löschen"
                            :onClick #(swap! !st assoc :show-delete cell-data)
                            }
           [delete-outline {:fontSize "small"}]])))))


(defn invite-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "jetzt Einladung senden"
                            :onClick #(swap! !st assoc :show-invite cell-data)
                            }
           [send {:fontSize "small"}]])))))

(defn accepted-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "auf `zugesagt` setzen"
                            :onClick #(swap! !st assoc :show-accept cell-data)
                            }
           [check {:fontSize "small"}]])))))


(defn select-renderer [!st ?ro]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/checkbox
         {:onChange (fn [_ val] (swap! !st assoc-in [:selected  cell-data] val))
          :disabled ?ro
          :checked (or (get-in @!st [:selected cell-data]) false)
          }
         ]))))


(defn inside-table [!st rows {:keys [ro? allow-delete? allow-accept? allow-invite? show-alarm-answer?]}]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !detail-search (r/cursor !st [:detail-search])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight 50
          :height (- height 250)
          :rowCount (count rows)
          :rowGetter (fn [i]
                       ;(println (str "rowGet " (aget i "index")))
                       (clj->js (nth rows (aget i "index"))))
          :rowClassName (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy @!sort
          :sortDirection (if @!reverse "DESC" "ASC")
          :rowHeight 45
          :width width
          :headerClassName "headerColumn"
          :className "TestTable2"}
         (log/debug "rerender " m " @!sort " @!sort " @!reverse " @!reverse  rows)

         [:> rv/Column
          {:label (r/as-element [mui/checkbox {:clickable "false"}])
           :dataKey (name :user-tomId)
           :className "bordered exampleColumn"
           :cellRenderer (select-renderer !st ro?)
           :width 70} [:a {:href ""}]]


         [:> rv/Column
          {:label     "TomId"
           :dataKey   "user-tomId"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     70}]


         [:> rv/Column
          {:label     "Vorname"
           :dataKey   "user-firstName"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     170}]
         [:> rv/Column
          {:label     "Nachname"
           :dataKey   "user-lastName"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Geburtstag"
           :dataKey   "user-birthday"
           :className "bordered exampleColumn"
           :cellRenderer date-renderer
           :width     170}]
         [:> rv/Column
          {:label     "Email"
           :dataKey   "user-email"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Handy"
           :dataKey   "user-phoneNumber"
           :className "bordered exampleColumn"
           :width     170}]

         (when show-alarm-answer?
           [:> rv/Column
            {:label     "Antwort"
             :dataKey   "response-time"
             :className "bordered exampleColumn"
             :cellRenderer date-time-renderer
             :width     100}])


         [:> rv/Column
          {:label        (r/as-element [info])
           :dataKey      (name :user-tomId)
           :className    "bordered exampleColumn"
           :cellRenderer info-cell-renderer
           :width        70} ]

         (when (and allow-invite? (not ro?))
           [:> rv/Column
            {:label        (r/as-element [send])
             :dataKey      (name :member-uuid)
             :className    "bordered exampleColumn"
             :cellRenderer (invite-cell-renderer !st)
             :width        70} ])


         [:> rv/Column
          {:label        "Status"
           :dataKey      (name :response)
           :className    "bordered exampleColumn"
           :cellRenderer response-state-cell-renderer
           :width        70} ]


         (when  (and allow-accept? (not ro?))
           [:> rv/Column
            {:label        (r/as-element [check])
             :dataKey      (name :member-uuid)
             :className    "bordered exampleColumn"
             :cellRenderer (accepted-cell-renderer !st)
             :width        70} ])


         (when (and allow-delete? (not ro?))
           [:> rv/Column
            {:label        (r/as-element [delete-outline])
             :dataKey      (name :member-uuid)
             :className    "bordered exampleColumn"
             :cellRenderer (remove-cell-renderer !st)
             :width        70} ])





         ]))))





(defn filter-fn [rows search ]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split  search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))

(defn get-sort-filter-rows [rows sort_ reverse_ filter_ ]
  (js/console.log "get-sort-filter-rows = "  rows)
  (let [rows (if rows (mapv (fn [[k v]] (assoc v :index k)) rows) [])
        rows (filter-fn rows filter_)
        rows (sort-by (keyword (if sort_ sort_ :user-lastName)) rows)
        rows (if reverse_ (reverse rows) rows)]
    rows))


(defn selected-actions [!st event-uuid {:keys [allow-accept? allow-decline?]} rows]
  (let [!show-accepted (r/cursor !st [:show-participated-multi])
        !show-absent (r/cursor !st [:show-absent-multi])
        !show-standby (r/cursor !st [:show-standby-multi])
        !show-remove (r/cursor !st [:show-remove-multi])
        !show-invite (r/cursor !st [:show-invite-multi])
        !show-invite-again (r/cursor !st [:show-invite-multi-again])
        !show-select-first (r/cursor !st [:show-select-first])
        !st-selected (r/cursor !st [:selected])
        !st-selection-action (r/cursor !st [:selected-action])
        update-fn (fn [] (reset! !st-selected {}) (d-training/training-update))
        select-first-fn (fn [& [max]] (reset! !st-selected (reduce (fn [c {tomId :user-tomId}] (log/debug "select all + " tomId) (assoc c tomId true)) @!st-selected (take (or max 1000000) rows))))
        ]
    [:div
     [enter-amount-modal/modal !show-select-first (str "Ersten X Personen auswählen. Anzahl eingeben bitte:") "Auswählen"
      (fn [amount] (select-first-fn amount))]
     [are-you-sure-modal/are-you-sure-modal !show-remove (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich aus der Veranstaltung entfernen?") "Entfernen"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "remove" nil #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-accepted (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Zugesagt` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "accepted" nil #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-standby (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Reserve` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "standby" nil #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-absent (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Nicht gekommen` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "absent" nil #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-invite (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich per Email einladen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "invite" nil #(update-fn)))]
     [are-you-sure-modal/are-you-sure-modal !show-invite-again (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich erneut per Email einladen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "invite-again" nil #(update-fn)))]

     [mui/icon-button {:title "Alle abwählen"
                       :onClick #(swap! !st assoc :selected {})
                       } [check-box-outline-blank {:fontSize "small"}]]
     [mui/icon-button {:title "Alle wählen"
                       :onClick #(select-first-fn)
                       } [check-box {:fontSize "small"}]]


     [mui/icon-button {:title "Ersten X wählen"
                       :style {:marginRight "15px"}
                       :onClick #(reset! !show-select-first true)
                       } [add {:fontSize "small"}]]

     [mui/select
      {:style {:width "300px"}
       :defaultValue "-"
       :onChange (fn [e] (reset! !st-selection-action (h/event-value e)))
       }
      [mui/menu-item {:value "-" } (str (count-true @!st-selected) " Auswahl")]
      (when allow-accept? [mui/menu-item {:value "accepted" } "-> Zugesagt"])
      [mui/menu-item {:value "invite-again" } "-> Erneut Einladung senden"]
      [mui/menu-item {:value "remove" } "-> Entfernen"]
      ]
     [mui/button {:disabled (if (or (nil? @!st-selection-action) (empty? @!st-selected) (= @!st-selection-action "-")) true false)
                  :onClick (fn []
                             (log/debug "übernehmen clicked " @!st-selection-action @!st-selected)
                             (case @!st-selection-action
                               "accepted" (reset! !show-accepted true)
                               "standby" (reset! !show-standby true)
                               "absent" (reset! !show-absent true)
                               "remove" (reset! !show-remove true)
                               "invite" (reset! !show-invite true)
                               "invite-again" (reset! !show-invite-again true)
                               :else nil))
                  } "übernehmen"]
     ]
    ))

(defn table-column [!st rows]
  (let [
        rows (get-sort-filter-rows rows (:sort @!st) (:reverse @!st) (:search @!st))
        cnt-rows (count rows)]

    (if (> cnt-rows 0)
      [(table/table !st rows)]
      [:h3 "Keine Ergebnisse gefunden!"])
    ))


(defn get-table [!st rows table-set]
  (fn [] [:> rv/AutoSizer
          {:style { :height "100%" :minHeight "400px"}
           :sort (str "rerender !st" @!st)}
          (inside-table !st rows table-set)]))

(defn get-it [member response-filter missionState-filter {:keys [ro? allow-accept? allow-decline?] :as table-set}]
  (let [!st (r/atom {:sort :user-lastName :reverse true :search "" :show-delete false :manipulate-tomId nil :show-mail false})
        !training (r/cursor vstate/app-state [:selected-training])
        user (into {} (map (fn [m] [(:trainingSlotMember-uuid m)
                                    (assoc (:trainingSlotMember-user m)
                                      :member-uuid (:trainingSlotMember-uuid m)
                                      :member-slot (:trainingSlotMember-slot m)
                                      :response (:trainingSlotMember-responseState m)
                                      :response-time (:trainingSlotMember-responseTime m)
                                      :mission (:trainingSlotMember-state m)
                                      )] )
                           (filter (fn [e]
                                     (log/debug "filter " response-filter " " (get-in e [:trainingSlotMember-user :user-tomId]) " " (some? (:trainingSlotMember-invitation e)) "-" (:trainingSlotMember-responseState e) " - " (:trainingSlotMember-state e))
                                     (and
                                       (case response-filter
                                         "invited" (and (some? (:trainingSlotMember-invitation e)) (= (or (:trainingSlotMember-responseState e) "unknown")  "unknown"))
                                         "accepted" (= (:trainingSlotMember-responseState e) "accepted")
                                         "member" (and (empty? (:trainingSlotMember-invitation e)) (= (or (:trainingSlotMember-responseState e) "unknown")  "unknown"))
                                         :else true)
                                       (if missionState-filter (= (or (:trainingSlotMember-state e) "undefined")  missionState-filter) true)
                                       )) member)))
        get-name-fn (fn [uuid] (if uuid (str (get-in user [uuid :user-tomId]) ") " (get-in user [uuid :user-firstName]) " " (get-in user [uuid :user-lastName]) ) ""))
        ]
    (fn []
      (let [!map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])
            !training-detail-loaded? (r/cursor vstate/app-state [:trainingEvent-detail-loaded])
            !show-delete (r/cursor !st [:show-delete])
            !show-accept (r/cursor !st [:show-accept])
            !show-decline (r/cursor !st [:show-decline])
            !show-invite (r/cursor !st [:show-invite])
            !show-invite-again (r/cursor !st [:show-invite-again])
            !show-mail (r/cursor !st [:show-mail])
            !sort (r/cursor !st [:sort])
            !reverse (r/cursor !st [:reverse])
            !search (r/cursor !st [:search])
            !waiting? (r/cursor !st [:waiting])
            rows (get-sort-filter-rows user @!sort @!reverse @!search)]
        (log/debug "training ROWS !!!!!!!!!!!!!!!!!!!!!!"  (count rows) table-set)
        [mui/grid
         {:container true
          :direction "row"
          :alignItems "stretch"
          :justify "flex-start"
          :style {:height "calc(100% - 64px)" :minHeight "600px"}
          }

         [toe-modal/get-modal !map-userPopup]
         [are-you-sure-modal/are-you-sure-modal !show-delete (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-delete) " << wirklich aus der Veranstaltung entfernen?") "Entfernen"
          (fn []
            (log/debug "entfernen " @!show-delete)
            (d-trainingMember/>member-drop @!show-delete #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-accept (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-accept) " << wirklich auf `zugesagt` setzen?") "Zusagen"
          (fn []
            (d-trainingMember/>member-save @!show-accept {:trainingSlotMember-responseState "accepted"} #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-decline (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-decline) " << wirklich auf `abgesagt` setzen?") "Absagen"
          (fn []
            (d-trainingMember/>member-save @!show-decline {:trainingSlotMember-responseState "declined"} #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-invite (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-invite) " << wirklich erneut einladen?") "Senden"
          (fn []
            (d-trainingMember/>member-invite @!show-invite #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-mail (str "Willst allen Personen in dieser Liste (" (count user) ") ein Email senden?") "senden"
          (fn [] (log/debug "email " (count user) ))]




         [mui/grid
          {:item true
           :xs 12}
          [ws-event-sync-component/ws-event-reload !training-detail-loaded? :training-event (:trainingEvent-uuid @!training)]
          ]

         [mui/grid
          {:item true
           :md 6
           :xs 6
           :style {:textAlign "left"} }
          (when-not ro?
            [selected-actions !st (:trainingEvent-uuid @!training) table-set rows])
          ]


         [mui/grid
          {:item true
           :md 3
           :xs 3
           :style {:textAlign "left"} }
          [mui/text-field
           {:default-value (str @!search)
            :placeholder "Suche in Liste ..."
            :style {:width "250px" :display "inline-block"}
            :onChange   (h/wait-do !waiting? #(reset! !search %))
            :multiline   false}]
          (log/debug "Search " @!search)
          (when false; (> (count @!search) 0)
            [mui/button {:variant "outlined"
                         :startIcon (r/as-element [close])
                         :onClick  (h/wait-do !waiting? (fn [_] (reset! !search "")))
                         :style {:margin-left "5px" :margin-right "25px"}} ""])
          ]

         [mui/grid
          {:item true
           :md 3
           :xs 3
           :style {:textAlign "right"} }
          [mui/button {:variant   "outlined"
                       :startIcon (r/as-element [cloud-download])
                       :onClick   #(d-trainingMember/open-csv (:trainingEvent-uuid @!training) response-filter missionState-filter {})
                       } "Csv Export"]
          ]

         [mui/grid
          {:item true
           :lg 12
           :xs 12
           :style {:textAlign "left"} }

          [(get-table !st rows table-set)]
          ]

         ]
        )
      )))

























